import {
  enumAssetFillState,
  enumAssetStatus,
} from '@rematter/frontend-lib-api-client';
import { atom } from 'jotai';

import { AssetFormState } from '~/modules/transportation/types';

const initialState: AssetFormState = {
  identifier: '',
  typeId: '',
  description: '',
  status: enumAssetStatus.Inventory,
  fillState: enumAssetFillState.Empty,
  customAttributes: {},
  tareWeight: null,
};

export const $assetForm = atom<AssetFormState>(initialState);

export const $updateAssetForm = atom(
  null,
  (get, set, update: Partial<AssetFormState>) => {
    const current = get($assetForm);
    set($assetForm, { ...current, ...update });
  },
);
